import { useState, FormEvent } from 'react';
import { useAuth } from '../authentication/hooks/auth';
import axios from '@/lib/axios';

const AccountDetails = () => {
  const { user } = useAuth();

  const [profileForm, setProfileForm] = useState({
    name: user?.data?.name || '',
  });
  const [passwordForm, setPasswordForm] = useState({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleProfileSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await axios.post('/api/v2/profile/update', {
        name: profileForm.name,
      });

      setMessage({
      
        text: 'Profile updated successfully!',
        type: 'success',
      });
    } catch (error: any) {
      setMessage({
        text: error.response?.data?.message || 'Error updating profile',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMessage({ text: '', type: '' });

    if (passwordForm.password !== passwordForm.password_confirmation) {
      setMessage({
        text: 'Passwords do not match',
        type: 'error',
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/api/v2/profile/update', {
        current_password: passwordForm.current_password,
        password: passwordForm.password,
      });

      setMessage({
        text: 'Password updated successfully!',
        type: 'success',
      });
      setPasswordForm({
        current_password: '',
        password: '',
        password_confirmation: '',
      });
    } catch (error: any) {
      setMessage({
        text: error.response?.data?.message || 'Error updating password',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard__content">
      <div className="dashboard__content-header">
        <h5>My Rewards</h5>
      </div>
      <div className="dashboard__content-info">
        <div className="account-pill">
          {message.text && (
            <div className={`alert alert-${message.type}`}>{message.text}</div>
          )}
          <div className="row g-3">
            <div className="col-12">
              <div className="bg-white rounded">
                <div className="py-3 border-bottom">
                  <h4 className="mb-0 px-4 fw-medium">Update Profile</h4>
                </div>
                <form
                  onSubmit={handleProfileSubmit}
                  className="account__form needs-validation p-4"
                >
                  <div className="row g-3">
                    <div className="col-12">
                      <div>
                        <label htmlFor="first-name" className="form-label">
                          Full name
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          id="first-name"
                          value={profileForm.name}
                          onChange={(e) =>
                            setProfileForm({
                              ...profileForm,
                              name: e.target.value,
                            })
                          }
                          placeholder="Enter Your Name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div>
                        <label htmlFor="account-phone" className="form-label">
                          Phone Number/Email
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          id="account-phone"
                          value={user?.data?.email || ''}
                          placeholder="Enter Your Number"
                          required
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="trk-btn trk-btn--primary mt-3"
                    disabled={loading}
                  >
                    {loading ? 'Updating...' : 'Update Profile'}
                  </button>
                </form>
              </div>
            </div>
            <div className="col-12">
              <div className="bg-white rounded">
                <div className="py-3 border-bottom">
                  <h4 className="mb-0 px-4 fw-medium">Update Password</h4>
                </div>
                <form
                  onSubmit={handlePasswordSubmit}
                  className="account__form needs-validation p-4"
                >
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="form-pass">
                        <label
                          htmlFor="current-password"
                          className="form-label"
                        >
                          Current Password
                        </label>
                        <input
                          type="password"
                          className="form-control showhide-pass"
                          id="current-password"
                          value={passwordForm.current_password}
                          onChange={(e) =>
                            setPasswordForm({
                              ...passwordForm,
                              current_password: e.target.value,
                            })
                          }
                          placeholder="Current password"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-pass">
                        <label htmlFor="account-pass" className="form-label">
                          New Password
                        </label>
                        <input
                          type="password"
                          className="form-control showhide-pass"
                          id="account-pass"
                          value={passwordForm.password}
                          onChange={(e) =>
                            setPasswordForm({
                              ...passwordForm,
                              password: e.target.value,
                            })
                          }
                          placeholder="New password (min 8 characters)"
                          required
                          minLength={8}
                        />
                        <p>Must be at least 8 characters.</p>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-pass">
                        <label htmlFor="account-cpass" className="form-label">
                          Confirm New Password
                        </label>
                        <input
                          type="password"
                          className="form-control showhide-pass"
                          id="account-cpass"
                          value={passwordForm.password_confirmation}
                          onChange={(e) =>
                            setPasswordForm({
                              ...passwordForm,
                              password_confirmation: e.target.value,
                            })
                          }
                          placeholder="Re-type new password"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="trk-btn trk-btn--primary mt-3"
                    disabled={loading}
                  >
                    {loading ? 'Updating...' : 'Update Password'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
